import { ChangeDetectionStrategy, Component, inject, OnInit, viewChild } from '@angular/core';
import { GeneralProjectService } from '@app/cem/project/services/general-project.service';
import { AppStorage } from '@app/common/services/data-api/app-storage.service';
import { HeaderComponent } from '@app/shared/components/header/header.component';
import { ButtonDirective } from '@progress/kendo-angular-buttons';
import { AgGridAngular } from 'ag-grid-angular';
import { DefaultTeamRig, ProjectTeamRigsGridOptions, ProjectTeamRigsGridOptionsService } from './columns';

@Component({
  selector: 'app-project-team-rigs',
  templateUrl: './project-team-rigs.component.html',
  styleUrls: ['./project-team-rigs.component.scss'],
  imports: [
    AgGridAngular,
    ButtonDirective,
    HeaderComponent,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [
    ProjectTeamRigsGridOptionsService
  ],
})
export class ProjectTeamRigsComponent implements OnInit {
  private generalProjectService = inject(GeneralProjectService);
  public projectTeamRigsGridOptionsService = inject(ProjectTeamRigsGridOptionsService);
  private appStorage = inject(AppStorage);

  private readonly agGrid = viewChild(AgGridAngular);

  public projectTeamRigsGridOptions: ProjectTeamRigsGridOptions;
  public currentAssetTeamId: number;
  public scenarioId: number;
  public loading: boolean = false;
  public editedRigs: Map<number, DefaultTeamRig> = new Map<any, DefaultTeamRig>();

  constructor() {
    this.projectTeamRigsGridOptions = this.projectTeamRigsGridOptionsService.projectTeamRigsGridOptions;
  }

  ngOnInit() {
    this.appStorage.knownEvents.assetTeamSelected.subscribe(event => {
      if (event && event.AssetTeamId !== this.currentAssetTeamId) {
        this.currentAssetTeamId = event.AssetTeamId;
        this.loadDefaultTeams();
      }
    });
    this.appStorage.knownEvents.scenarioSelected.subscribe(event => {
      if (event && event.ScenarioId !== this.scenarioId) {
        this.scenarioId = event.ScenarioId;
        this.refreshData();
      }
    });
  }

  loadDefaultTeams() {
    this.generalProjectService.getDefaultProjecTeams(this.currentAssetTeamId, 2).then(
      teams => {
        this.projectTeamRigsGridOptionsService.DefaultProjectTeams = new Map(teams.map(a => [a.DefaultProjectTeamId, a]));
      }
    );
  }

  onGridReady(params) { }

  refreshData() {
    this.loading = true;
    this.generalProjectService.getProjectTeamRigDefaults(this.scenarioId).then(
      rigs => {
        this.agGrid().api.setGridOption('rowData', rigs);
        this.loading = false;
      }
    );
  }

  cancelEdit() {
    this.editedRigs = new Map<any, DefaultTeamRig>();
    this.refreshData();
  }

  onCellValueChanged(e) {
    this.trackChanges(e);
  }

  onRowEditStopped(e) {
    this.trackChanges(e);
  }

  trackChanges(e) {
    let defaultTeamRig: DefaultTeamRig = {
      RigId: e.data.RigId,
      DefaultRigId: e.data.DefaultRigId,
      DefaultProjectTeamId: e.data.DefaultProjectTeamId,
      Name: e.data.Name
    };

    this.editedRigs.set(e.node.id, defaultTeamRig);
  }

  saveChanges() {
    this.loading = true;
    let rigs = this.editedRigs.values();
    this.generalProjectService.addUpdateDefaultRigTeams(Array.from(rigs)).subscribe(x => {
      this.editedRigs = new Map<any, DefaultTeamRig>();
      this.loading = false;
      this.refreshData();
    });
  }
}